import React, { useRef, useState, useEffect } from "react";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../../components/FormValidation";
import useFormValidation from "../../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../../utils/helpers/formValidation";

const roleSchema = { name: rule.required("Nama role wajib diisi.") };

const FormRole = (props) => {
  const { isShowModal: _isShowModal, isEdit, closeModal, formState, setFormState, handleAdd, handleUpdate: _handleUpdate, handleUpdateRole } = props;
  const [_showPassword, _setShowPassword] = useState(false);
  const inputRefName = useRef(null);
  const formRef = useRef(null);
  const validation = useFormValidation({ values: formState, schema: roleSchema, formId: "role", focusRoot: formRef });
  const _inputRef = useRef(null);
  useEffect(() => {
    inputRefName.current?.focus();
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!validation.validateAll()) return;
    const success = isEdit ? await handleUpdateRole() : await handleAdd();
    if (success !== false) document.querySelector("#modal-form .btn-close")?.click();
  };

  const _options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" }];


  return (
    <div
      className="modal modal-blur fade "
      id="modal-form"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)"
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <form ref={formRef} className="modal-content" onSubmit={submit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">Master Role {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row">
              <div className="col-lg-12">
                <label className="form-label">Nama Role<RequiredMark /></label>
                <div className="mb-3 input-icon">
                  <span className="input-icon-addon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                      <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                    </svg>
                  </span>
                  <input
                    {...validation.fieldProps("name")}
                    ref={inputRefName}
                    type="text"
                    className={validation.inputClass("name")}
                    placeholder="Contoh: Supervisor Outlet"
                    value={formState?.name || ""}
                    onChange={(e) =>
                    setFormState((prev) => ({
                      ...prev,
                      name: e.target.value
                    }))
                    } />
                  <FieldFeedback formId="role" name="name" error={validation.errors.name} hint="Nama role harus unik." />

                </div>
              </div>
              <div className="col-lg-12">
                <label className="form-label">Deskripsi</label>
                <div className="mb-3 input-icon">
                  <span className="input-icon-addon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-text-icon lucide-text">
                      <path d="M15 18H3" />
                      <path d="M17 6H3" />
                      <path d="M21 12H3" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="description"
                    placeholder="Jelaskan tanggung jawab role ini"
                    value={formState?.description || ""}
                    onChange={(e) =>
                    setFormState((prev) => ({
                      ...prev,
                      description: e.target.value
                    }))
                    } />

                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              {" "}
              Batal{" "}
            </button>
            {isEdit ?
            <button type="submit" className="btn btn-primary btn-5 ms-auto">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                Simpan Perubahan
              </button> :

            <button type="submit" className="btn btn-primary btn-5 ms-auto">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-2">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                Tambah Role
              </button>
            }
          </div>
        </form>
      </div>
    </div>);

};

export default FormRole;
